import { Component } from "preact";
import { isMobileOnly } from "react-device-detect";
import { connectWithTranslations } from "../../../../common/helpers/translationsHelpers";
import { getSetting } from "../../../../common/helpers/settingStorageHelpers";
import { TIME_FILTERS_VALUES, SETTING_KEYS } from "../../../constants";
import DatePickerFilterMobile from "../DatePickerFilterMobile";
import DatePickerFilterDesktop from "../DatePickerFilterDesktop";
import TimezonePicker from "./TimezonePicker";
import actions from "../../../actions";
import { persistSettings } from "../../../../calendar-common/helpers/settingsHelper";

class TimeFilter extends Component {
    constructor(props) {
        super(props);

        this.onTimezoneChanged = this.onTimezoneChanged.bind(this);
        this.renderTitle = this.renderTitle.bind(this);
        this.renderOption = this.renderOption.bind(this);
        this.onOptionSelected = this.onOptionSelected.bind(this);
    }

    componentWillMount() {
        const { timezones } = this.props;
        this.setState({
            timezones: timezones,
        });
    }

    onTimezoneChanged(timezone) {
        this.props.changeTimezoneAndFetch(timezone);

        let settings = getSetting(SETTING_KEYS.Settings);
        if (!settings) settings = this.props.defaultSettings;

        var timezoneOffset = timezone.OffsetValue;
        persistSettings({ ...settings, timezoneOffset });
    }
    onOptionSelected(option) {
        this.props.onTimeFilterChanged(option);
    }

    renderTitle(selectedOption, isOpen, upButton, downButton) {
        return (
            <span>
                <span class="fxs_inner">
                    {this.props.translate(selectedOption)}
                </span>
                {isOpen ? upButton : downButton}
            </span>
        );
    }

    renderOption(option) {
        return <span>{this.props.translate(option)}</span>;
    }

    render({
        time,
        dateRange,
        onTimeFilterChanged,
        onDateRangeFilterChanged,
        onChangeCustomFilter,
        applyFilter,
        showDatePicker = true,
        getCalendarTimeOptionGtmId,
        getCalendarTimeOptionGa4Id,
        getCalendarButtonGtmId,
        getCalendarButtonGa4Id,
        getGa4Name,
        settings,
    }) {
        const values = Object.values(TIME_FILTERS_VALUES);
        const buttonsValues = values;

        return (
            <div class="fxs_c_time-filters">
                {showDatePicker &&
                    (isMobileOnly ? (
                        <div class="fxs_c_time_wrapper">
                            <DatePickerFilterMobile
                                dateRange={dateRange}
                                onDateRangeFilterChanged={
                                    onDateRangeFilterChanged
                                }
                                applyFilter={applyFilter}
                                getButtonGtmId={getCalendarButtonGtmId}
                                getButtonGa4Id={getCalendarButtonGa4Id}
                                getContentGtmId={getCalendarTimeOptionGtmId}
                                getContentGa4Id={getCalendarTimeOptionGa4Id}
                                getGa4Name={getGa4Name}
                                buttonValues={buttonsValues}
                                showHighlighted={true}
                                time={time}
                                onTimeFilterChanged={onTimeFilterChanged}
                                onChangeCustomFilter={onChangeCustomFilter}
                            />
                            <TimezonePicker
                                onTimezoneChanged={this.onTimezoneChanged}
                                currentTimezone={settings.timezoneOffset}
                            />
                        </div>
                    ) : (
                        <DatePickerFilterDesktop
                            dateRange={dateRange}
                            onDateRangeFilterChanged={onDateRangeFilterChanged}
                            applyFilter={applyFilter}
                            getButtonGtmId={getCalendarButtonGtmId}
                            getButtonGa4Id={getCalendarButtonGa4Id}
                            getContentGtmId={getCalendarTimeOptionGtmId}
                            getContentGa4Id={getCalendarTimeOptionGa4Id}
                            getGa4Name={getGa4Name}
                            buttonValues={buttonsValues}
                            showHighlighted={true}
                            time={time}
                            onTimeFilterChanged={onTimeFilterChanged}
                            onChangeCustomFilter={onChangeCustomFilter}
                        />
                    ))}
            </div>
        );
    }
}

export default connectWithTranslations('settings,defaultSettings', actions)(TimeFilter);
